/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Inbox {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List all saved inbox filters for the current user.
   *
   * @tags Inbox
   * @name ListFilters
   * @summary List Filters
   * @request GET:/api/inbox/filters
   * @secure
   */
  listFilters = (params = {}) =>
    this.http.request({
      path: `/api/inbox/filters`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create a new saved inbox filter for the current user.
   *
   * @tags Inbox
   * @name CreateFilter
   * @summary Create Filter
   * @request POST:/api/inbox/filters
   * @secure
   */
  createFilter = (data, params = {}) =>
    this.http.request({
      path: `/api/inbox/filters`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve an individual saved inbox filter.
   *
   * @tags Inbox
   * @name GetFilter
   * @summary Get Filter
   * @request GET:/api/inbox/filters/{filter_id}
   * @secure
   */
  getFilter = (filterId, params = {}) =>
    this.http.request({
      path: `/api/inbox/filters/${filterId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update an existing saved inbox filter.
   *
   * @tags Inbox
   * @name UpdateFilter
   * @summary Update Filter
   * @request PUT:/api/inbox/filters/{filter_id}
   * @secure
   */
  updateFilter = (filterId, data, params = {}) =>
    this.http.request({
      path: `/api/inbox/filters/${filterId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a saved inbox filter.
   *
   * @tags Inbox
   * @name DeleteFilter
   * @summary Delete Filter
   * @request DELETE:/api/inbox/filters/{filter_id}
   * @secure
   */
  deleteFilter = (filterId, params = {}) =>
    this.http.request({
      path: `/api/inbox/filters/${filterId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Create Item.
   *
   * @tags Inbox
   * @name CreateItem
   * @summary Create Item
   * @request POST:/api/inbox
   * @secure
   */
  createItem = (data, params = {}) =>
    this.http.request({
      path: `/api/inbox`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description List Items.
   *
   * @tags Inbox
   * @name ListItems
   * @summary List Items
   * @request GET:/api/inbox
   * @secure
   */
  listItems = (query, params = {}) =>
    this.http.request({
      path: `/api/inbox`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Metrics.
   *
   * @tags Inbox
   * @name GetMetrics
   * @summary Get Metrics
   * @request GET:/api/inbox/metrics
   * @secure
   */
  getMetrics = (params = {}) =>
    this.http.request({
      path: `/api/inbox/metrics`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get Unread Inbox Count for the current user.
   *
   * @tags Inbox
   * @name GetUnreadCount
   * @summary Get Unread Count
   * @request GET:/api/inbox/unread-count
   * @secure
   */
  getUnreadCount = (params = {}) =>
    this.http.request({
      path: `/api/inbox/unread-count`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Bulk Update.
   *
   * @tags Inbox
   * @name BulkUpdate
   * @summary Bulk Update
   * @request POST:/api/inbox/bulk
   * @secure
   */
  bulkUpdate = (data, params = {}) =>
    this.http.request({
      path: `/api/inbox/bulk`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieve an individual inbox item.
   *
   * @tags Inbox
   * @name GetItem
   * @summary Get Item
   * @request GET:/api/inbox/{item_id}
   * @secure
   */
  getItem = (itemId, params = {}) =>
    this.http.request({
      path: `/api/inbox/${itemId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Update Item.
   *
   * @tags Inbox
   * @name UpdateItem
   * @summary Update Item
   * @request PUT:/api/inbox/{item_id}
   * @secure
   */
  updateItem = (itemId, data, params = {}) =>
    this.http.request({
      path: `/api/inbox/${itemId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete an individual inbox item.
   *
   * @tags Inbox
   * @name DeleteItem
   * @summary Delete Item
   * @request DELETE:/api/inbox/{item_id}
   * @secure
   */
  deleteItem = (itemId, params = {}) =>
    this.http.request({
      path: `/api/inbox/${itemId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}
